import React from 'react';
import classNames from 'classnames';

import styles from './ConfSizePicker.module.less';
import AbstractPicker, { connect } from '../AbstractPicker';
import { translate } from '../../../services/L10n';
import { t } from '../../../translations';
import { metricToImperial } from '../../../util/measures';
import { range } from '../range';
import { getWidthText } from '../../../scene/util/dimensionDisplay';

class ConfSizePicker extends AbstractPicker {
  state = {
    options: [],
  };

  getLabelText(dimensionValue) {
    const { dimension, useMetricMeasures } = this.props;

    let dimensionLabel;
    let displayValue = useMetricMeasures
      ? dimensionValue / 10
      : metricToImperial(dimensionValue).onlyInches;
    switch (dimension) {
      case 'depth':
        dimensionLabel = translate(t.SHORT_LABEL_DEPTH);
        break;
      case 'width':
        dimensionLabel = translate(t.SHORT_LABEL_WIDTH);
        displayValue = getWidthText({
          ...this.props,
          item: { width: dimensionValue },
        });
        break;
      default:
        break;
    }

    return `${dimensionLabel} ${displayValue} ${
      this.props.useMetricMeasures
        ? translate(t.MEASURE_VALUE_CM)
        : translate(t.MEASURE_VALUE_IN)
    }`;
  }

  itemsAsOptions() {
    const { dimension } = this.props;

    return this.props.items.map(item => ({
      display: item[dimension],
      value: item.filter[dimension],
      id: item.id,
      type: item.filter.type,
    }));
  }

  render() {
    const { selected, dimension, wrapped } = this.props;
    const options = this.itemsAsOptions().sort((a, b) =>
      a.value < b.value ? 1 : a.value > b.value ? -1 : 0
    );
    options.forEach(option => {
      option.moveDirection = range.getMoveDirection(
        selected,
        option,
        dimension,
        this.props.tac
      );
    });

    return (
      <div className={classNames(styles.wrapper, wrapped && styles.wrapped)}>
        {options.map((option, index) => {
          const disabled =
            this.props.disabled ||
            !(option.id === selected.id || option.moveDirection);

          return (
            <div key={index}>
              <label
                htmlFor={option.id + option.value}
                className={classNames(
                  styles.text,
                  disabled && styles.disabledText
                )}
              >
                <input
                  type="radio"
                  disabled={disabled}
                  id={option.id + option.value}
                  checked={option.id === selected.id}
                  data-testid={`size-${option.value}`}
                  onChange={() =>
                    this.switch({
                      from: selected,
                      to: option,
                      switchingProp: dimension,
                    })
                  }
                />
                <span>{this.getLabelText(option.display)}</span>
              </label>
            </div>
          );
        })}
      </div>
    );
  }
}

export default connect(ConfSizePicker);
